import * as React from 'react';
import { useAtomValue } from 'jotai';
import { CheckBadgeIcon } from '@heroicons/react/24/solid';
import { useTranslation } from 'next-i18next';

import { restaurantDetailsAtom, ShowcaseSectionTitle } from '.';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface IVenueValuesProps {}

const VenueValues: React.FunctionComponent<IVenueValuesProps> = (props) => {
  const { t } = useTranslation('restaurant-showcase-v2');
  const restaurantDetails = useAtomValue(restaurantDetailsAtom);

  const restaurantValuesList = React.useMemo(
    () =>
      restaurantDetails?.values?.length > 0 ? (
        <div className="self-stretch inline-flex flex-col justify-start items-start gap-4 flex-wrap content-start">
          {restaurantDetails?.values?.map((value, index) => (
            <div key={index} className="self-stretch inline-flex justify-center items-center gap-1">
              <CheckBadgeIcon className="text-purple-500 w-5 h-5 relative self-start top-[1.2px]" />
              <h5 className="flex-1 justify-start text-neutral-700 text-base font-normal">{value}</h5>
            </div>
          ))}
        </div>
      ) : (
        <h5 className="self-stretch justify-start text-neutral-700 text-base font-normal">
          {t('no_values_specified')}
        </h5>
      ),
    [restaurantDetails?.values, t]
  );
  return (
    restaurantDetails?.values?.length > 0 && (
      <div className="self-stretch inline-flex flex-col justify-start items-start gap-4">
        <ShowcaseSectionTitle title={t('our_values')} />
        {restaurantValuesList}
      </div>
    )
  );
};

export default VenueValues;
